module.exports = __webpack_public_path__ + "static/media/6COPUOS3.79d76a27.jpg";